import Stack from '@mui/material/Stack'
import LoadingButton from '@mui/lab/LoadingButton'
import RefreshIcon from '@mui/icons-material/Refresh'
import IconButton from '@mui/material/IconButton'
import { useCallback, useState } from 'react'
import { errorMessage } from '../../../helpers/errorMessageFunc'
import { backendPostWithoutRefresh, backendPatchWithoutRefresh } from '../../../helpers/callBackend'
import { downloadCSV } from '../../../helpers/downloadPDF'

const ReportRunActions = ({ reportId, runInfo, reportName }) => {
  const [isResetting, setIsResetting] = useState(false)
  const [isDownloading, setIsDownloading] = useState(false)

  const handleDownload = useCallback(async () => {
    try {
      setIsDownloading(true)
      const downloadResp = await backendPostWithoutRefresh('/api/reports/v2/download/', {
        report_builder_id: reportId,
        run_date: runInfo.run_date,
      })
      downloadCSV(downloadResp?.data?.data, `${reportName}-${runInfo.run_date}`)
      setIsDownloading(false)
    } catch (error) {
      errorMessage(error.message)
      setIsDownloading(false)
    }
  }, [reportId, runInfo])

  const handleReset = useCallback(async () => {
    try {
      setIsResetting(true)
      const reset = await backendPatchWithoutRefresh('/api/reports/v2/report-builder-run/', {
        report_builder_id: reportId,
        run_date: runInfo.run_date,
      })
      setIsResetting(false)
    } catch (error) {
      errorMessage(error.message)
      setIsResetting(false)
    }
  }, [reportId, runInfo])

  return (
    <Stack direction='row' alignItems='center' justifyContent='end' sx={{ height: '100%' }} spacing={1}>
      <IconButton color='primary' onClick={handleReset}>
        <RefreshIcon
          sx={{
            fontSize: 20,
            animation: isResetting ? 'spin 1s linear infinite' : 'none',
            '@keyframes spin': {
              '0%': { transform: 'rotate(0deg)' },
              '100%': { transform: 'rotate(360deg)' },
            },
          }}
        />
      </IconButton>
      <LoadingButton
        onClick={handleDownload}
        loading={isDownloading}
        disabled={isResetting}
        loadingPosition='start'
        sx={{ fontSize: 14, textTransform: 'none', width: '175px' }}
        disableElevation
        fullWidth
        size='small'
        variant='contained'
        color='primary'
      >
        Download CSV
      </LoadingButton>
    </Stack>
  )
}

export default ReportRunActions
